import styled from 'styled-components';

export const ScCookiePopup = styled.div`
  position: relative;
  width: min(905px, calc(100% - 16px));
  margin-inline: auto;
  display: flex;
  align-items: center;
  gap: 12px 8px;
  padding: 16px;
  background-color: ${({ theme }) => theme.whiteColor};
  border-radius: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${({ theme }) => theme.blackColor};
  text-transform: none;
  box-shadow:
    0px 0px 10px 0px #000000cc,
    0px 10px 10px 0px #00000066;

  @media (max-width: 768px) {
    position: fixed;
    left: 8px;
    bottom: 8px;
    flex-direction: column;
    text-align: center;
    z-index: 1001;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 2px;
    pointer-events: none;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    background: linear-gradient(
      90deg,
      #2d4085 0%,
      #0c6ae6 16.5%,
      #bb1eb5 37.5%,
      #db0600 57.5%,
      #fd3500 80%,
      #ffad0e 99%
    );
  }

  & > a {
    position: relative;
    z-index: 1;
    @media (max-width: 768px) {
      align-self: stretch;
    }
    button {
      min-width: auto;
      @media (max-width: 768px) {
        width: 100%;
      }
    }
  }
`;
